// extracted by mini-css-extract-plugin
module.exports = {"MaskContentImage":"InformationBanner_MaskContentImage__kw1qM","InformationBanner":"InformationBanner_InformationBanner__60Xfg"};